import React from "react";
import Layout from "@/components/Layout";
import { Card } from "@/components/ui/card";

/**
 * LegalPage — shared layout for Impressum / Datenschutz / Barrierefreiheit.
 * Renders structured sections with stable typography. Content is plain JSX
 * passed in by the consumer.
 */
export default function LegalPage({ title, subtitle, lastUpdated, children, testid }) {
  return (
    <Layout title={title} subtitle={subtitle}>
      <div className="max-w-3xl">
        <Card className="p-6 sm:p-8 leading-relaxed text-[15px]" data-testid={testid}>
          {lastUpdated && (
            <p className="text-xs text-zinc-400 mb-6 uppercase tracking-wider font-semibold">
              Stand: {lastUpdated}
            </p>
          )}
          <div
            className="space-y-3 text-zinc-700 [&_h2]:font-display [&_h2]:tracking-tight [&_h2]:font-bold [&_h2]:text-xl [&_h2]:mt-10 [&_h2]:mb-3 [&_h2]:text-zinc-900 [&_h3]:font-display [&_h3]:tracking-tight [&_h3]:font-semibold [&_h3]:text-lg [&_h3]:mt-6 [&_h3]:mb-2 [&_h3]:text-zinc-900 [&_p]:leading-relaxed [&_p]:my-3 [&_a]:text-emerald-700 [&_a]:underline [&_a]:underline-offset-2 [&_strong]:text-zinc-900 [&_strong]:font-semibold [&_ul]:my-3 [&_ul]:pl-6 [&_ul]:list-disc [&_li]:my-1.5 [&_code]:bg-zinc-100 [&_code]:px-1 [&_code]:py-0.5 [&_code]:rounded [&_code]:text-[13px]"
          >
            {children}
          </div>
        </Card>
      </div>
    </Layout>
  );
}
